/* Kyriacou — theme.js
   Mobile menu, bag drawer (AJAX cart), product form, gallery, slideshow, recommendations. No dependencies. */
(function () {
  'use strict';
  var KC = window.KC || {};
  var body = document.body;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function money(cents) {
    var fmt = KC.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    function fixed(d, sep, dec) {
      var s = n.toFixed(d);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    var out = fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', fixed(0, '.', ','))
      .replace('{{amount_with_comma_separator}}', fixed(2, '.', ','))
      .replace('{{amount_no_decimals}}', fixed(0, ',', '.'))
      .replace('{{amount_with_space_separator}}', fixed(2, ' ', ','))
      .replace('{{amount}}', fixed(2, ',', '.'));
    /* whole-dollar amounts read "$80", not "$80.00" (matches money_without_trailing_zeros) */
    return out.replace(/[.,]00(?!\d)/, '');
  }
  var toastEl = $('#Toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  /* ---------- header menu ---------- */
  var menuBtn = $('.js-menu'), mobileNav = $('#MobileNav');
  on(menuBtn, 'click', function () {
    var open = mobileNav.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- bag drawer ---------- */
  var drawer = $('#CartDrawer');
  function openCart() { if (!drawer) return; body.classList.add('cart-open'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { if (!drawer) return; body.classList.remove('cart-open'); drawer.setAttribute('aria-hidden', 'true'); }
  function bindDrawer() {
    $$('.js-cart-close').forEach(function (b) { on(b, 'click', closeCart); });
    $$('.js-qty', drawer).forEach(function (b) {
      on(b, 'click', function () { changeLine(b.getAttribute('data-key'), parseInt(b.getAttribute('data-qty'), 10)); });
    });
  }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; if (parseInt(n, 10) > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', ''); }); }
  function flash(btn) {
    if (!btn) return;
    var span = btn.querySelector('span') || btn, was = span.textContent;
    span.textContent = (KC.strings && KC.strings.added) || 'Added';
    setTimeout(function () { span.textContent = was; }, 1600);
  }
  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    drawer.classList.add('is-busy');
    return fetch((KC.rootUrl || '/') + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var c = tmp.querySelector('[data-cart-count]');   /* grab it before the drawer markup is moved out of tmp */
        var fresh = tmp.querySelector('.drawer-inner');
        var cur = drawer.querySelector('.drawer-inner');
        if (fresh && cur) { cur.replaceWith(fresh); bindDrawer(); }
        if (c) setCount(c.textContent.trim());
      })
      .catch(function () {})
      .then(function () { drawer.classList.remove('is-busy'); });
  }
  function changeLine(key, qty) {
    return fetch(KC.cartChangeUrl || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { setCount(cart.item_count); return refreshDrawer(); });
  }
  function addFromForm(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    return fetch(KC.cartAddUrl || '/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        flash(btn);
        return refreshDrawer().then(function () {
          if (KC.cartDrawer === false) { window.location.href = KC.cartUrl || '/cart'; return; }
          openCart();
        });
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  on(document, 'submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('.js-add-form, .js-product-form')) { e.preventDefault(); addFromForm(form); }
  });
  on(document, 'click', function (e) {
    var open = e.target.closest && e.target.closest('.js-cart-open');
    if (open) { e.preventDefault(); refreshDrawer().then(openCart); }
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { closeCart(); } });
  bindDrawer();

  /* ---------- quantity steppers (product + cart page) ---------- */
  on(document, 'click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(parseInt(input.min, 10) || 0, v + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product page ---------- */
  var pform = $('.js-product-form');
  var pjson = $('[data-product-json]');
  if (pform && pjson) {
    var product; try { product = JSON.parse(pjson.textContent); } catch (e) { product = null; }
    var selects = $$('.js-option', pform);
    var idInput = pform.querySelector('[data-variant-id]');
    var priceEls = $$('[data-price]');
    var saveEls = $$('[data-save]');
    var addBtn = pform.querySelector('.js-add');
    function activateMedia(id) {
      if (!id) return;
      var items = $$('.gallery-item'), thumbs = $$('.thumb'), hit = false;
      items.forEach(function (it) { var m = it.getAttribute('data-media-id') === String(id); it.classList.toggle('is-active', m); if (m) hit = true; });
      if (hit) thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(id)); });
    }
    function update() {
      if (!product) return;
      var chosen = selects.map(function (s) { return s.value; });
      var v = product.variants.filter(function (vv) { return chosen.every(function (c, i) { return vv.options[i] === c; }); })[0];
      var str = KC.strings || {};
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = str.unavailable || 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (el) { el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price); });
      saveEls.forEach(function (el) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        el.hidden = !onSale;
        if (onSale) {
          var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          var label = el.getAttribute('data-label');
          el.textContent = (label ? label + ' \u00b7 ' : '') + (el.getAttribute('data-fmt') || 'Save PCT%').replace('PCT', pct);
        }
      });
      var stickyBtn = $('.js-sticky-add'); if (stickyBtn) stickyBtn.disabled = !v.available;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.querySelector('span').textContent = v.available ? (str.addToCart || 'Add to cart') : (str.soldOut || 'Sold out'); }
      if (v.featured_media) activateMedia(v.featured_media.id);
      try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url); } catch (e) {}
    }
    selects.forEach(function (s) { on(s, 'change', update); });
    $$('.thumb').forEach(function (t) { on(t, 'click', function () { activateMedia(t.getAttribute('data-media-id')); }); });
  }

  /* ---------- sticky add to cart ---------- */
  var sticky = $('.sticky-atc'), buyRow = $('.buy');
  if (sticky && buyRow) {
    var stickyTick = false;
    function checkSticky() { stickyTick = false; sticky.classList.toggle('is-visible', buyRow.getBoundingClientRect().bottom < 0); }
    function onScroll() { if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(checkSticky); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    checkSticky();
    on($('.js-sticky-add'), 'click', function () {
      if (!pform) return;
      if (pform.requestSubmit) pform.requestSubmit(); else pform.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- product recommendations ---------- */
  var recs = $('.recs[data-url]');
  if (recs) {
    fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('.recs');
      if (inner && inner.innerHTML.trim()) recs.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------- slideshow ---------- */
  $$('.slides').forEach(function (root) {
    var slides = $$('.slide', root), dots = $$('.dots button', root), label = $('.dots span', root);
    var i = 0, timer, auto = root.getAttribute('data-autoplay') === 'true' && !reduce && slides.length > 1;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (label) label.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
    }
    function start() { if (auto) { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, parseInt(root.getAttribute('data-interval'), 10) || 6000); } }
    on($('.prev', root), 'click', function () { show(i - 1); start(); });
    on($('.next', root), 'click', function () { show(i + 1); start(); });
    dots.forEach(function (d, k) { on(d, 'click', function () { show(k); start(); }); });
    on(root, 'mouseenter', function () { clearInterval(timer); });
    on(root, 'mouseleave', start);
    show(0); start();
  });

  /* ---------- hero video: hold still for people who ask for less motion ---------- */
  if (reduce) { $$('video.hero-video').forEach(function (v) { try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {} }); }

  /* ---------- "Notify me" buttons jump to the footer signup and focus it ---------- */
  on(document, 'click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#Newsletter"]');
    if (!a) return;
    var input = document.getElementById('NewsletterEmail');
    if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (err) {} }, 500);
  });

  /* ---------- toggles (address edit forms etc.) ---------- */
  on(document, 'click', function (e) {
    var t = e.target.closest && e.target.closest('[data-toggle]');
    if (!t) return;
    e.preventDefault();
    var target = document.getElementById(t.getAttribute('data-toggle'));
    if (target) { target.classList.toggle('open'); target.hidden = false; }
  });
})();
